module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('separator'), _vm._v(" "), _c('h5', {
    staticClass: "subtitle reveal is-5"
  }, [_vm._v("\n      Looking for exiting development opportunties and friendly greets 👋\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "block reveal"
  }, [_c('a', {
    staticClass: "button grow is-dark",
    attrs: {
      "href": ("mailto:" + _vm.email)
    }
  }, [_c('span', [_vm._v("Ping me")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "terminal",
      "size": "is-small"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78a064d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 545
// module chunks = 1